import styles from './OnePlatformSection.module.css';
import { PrimaryCta } from './PrimaryCta';

type OnePlatformSectionProps = {
	onCta: () => void;
};

export const OnePlatformSection = ({ onCta }: OnePlatformSectionProps) => (
	<section className={styles.section}>
		<div className={styles.grid} aria-hidden="true" />
		<div className={styles.stage}>
			<div className={styles.copyBlock}>
				<span className={styles.eyebrow}>One platform, every channel</span>
				<h2 className={styles.heading}>
					Stop juggling,
					<br />
					start consolidating.
				</h2>
				<p className={styles.sub}>
					Project Bridgeway handles email, SMS, voice, social, and creative in
					one place with agents that actually talk to each other.
				</p>
				<div className={styles.cta}>
					<PrimaryCta
						onClick={onCta}
						variant="dark"
						label="Try Project Bridgeway"
					/>
				</div>
			</div>
		</div>
	</section>
);
